import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";

import { LktAvatarComponent, LktUserBottomSheetComponent } from "@frontends-v3/design-system";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";

import { UserAccountBaseDirective } from "../app-menu/user-account-base.directive";

@Component({
  selector: "app-shared-user-bottom-sheet",
  standalone: true,
  imports: [LktAvatarComponent, LktUserBottomSheetComponent],
  providers: [NzModalService, NzMessageService],
  templateUrl: "./app-user-bottom-sheet.component.html",
  styleUrl: "./app-user-bottom-sheet.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSharedUserBottomSheetComponent extends UserAccountBaseDirective {
  public readonly appVersion = input.required<string>();
  public readonly label = input<string>("Você");
  public readonly dataCy = input<string>("user-bottom-sheet-trigger");

  public readonly isOpen = signal<boolean>(false);

  public openSheet(): void {
    this.isOpen.set(true);
    this.helpCenterState.retryIfErrored();
  }

  public onVisibleChange(visible: boolean): void {
    this.isOpen.set(visible);
  }

  public onItemClick(itemId: string): void {
    this.onPopoverItemClick(itemId);
    this.isOpen.set(false);
  }

  public onSwitchProfileClick(): void {
    this.onSwitchProfile();
    this.isOpen.set(false);
  }
}
